import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const SignagePreview = ({ facilityId }) => {
  const [url, setUrl] = useState(''); // State to store the input URL
  useEffect(() => {
    setUrl(
      `https://centaracare.com/digital-signage?facility=${facilityId}&only=activities`,
    );
  }, [facilityId]);
  // Automatically update iframeSrc as the user types
  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
        Signage Preview:
      </Typography>

      <Box
        sx={{
          width: '100%',
          mb: 2,
          aspectRatio: '16/9',
        }}
      >
        <iframe
          src={url}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
            borderRadius: '0.4rem',
          }}
        />
      </Box>

      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
        Signage Link:
      </Typography>
      <input
        value={url}
        onChange={handleUrlChange}
        placeholder="https://example.com"
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          fontSize: '16px',
          color: 'gray',
          border: '3px solid black',
          borderRadius: 10,
        }}
      />
    </Box>
  );
};
SignagePreview.propTypes = {
  facilityId: PropTypes.string,
};
export default SignagePreview;
